import React, { memo } from 'react';
import type { AccessibilityRole } from 'react-native';

import { LoadMain } from './LoadMain';
import type { LoadMainVariant } from './types';

/** Full-screen bootstrap loaders (`App.tsx`, `AppInitializerGate`). */
export const BOOTSTRAP_MAIN_LOADER_SIZE = 128;

export type MainLoaderProps = {
  /**
   * @deprecated Legacy Skia geometry prop — ignored.
   */
  circles?: number;
  size?: number;
  color?: string;
  trackColor?: string;
  loopDurationMs?: number;
  accessibilityLabel?: string;
  accessibilityRole?: AccessibilityRole;
  variant?: LoadMainVariant;
};

/**
 * App-wide loader — Reanimated + SVG only (no Skia).
 * Default variant: `pulse`.
 */
export const MainLoader = memo(function MainLoader({
  circles: _circles,
  size = 32,
  color,
  trackColor,
  loopDurationMs = 1100,
  accessibilityLabel,
  accessibilityRole,
  variant = 'pulse',
}: MainLoaderProps) {
  const a11y_role: AccessibilityRole | undefined =
    accessibilityLabel != null && accessibilityLabel !== ''
      ? (accessibilityRole ?? 'progressbar')
      : accessibilityRole;

  return (
    <LoadMain
      variant={variant}
      size={size}
      color={color}
      trackColor={trackColor}
      loopDurationMs={loopDurationMs}
      accessibilityLabel={accessibilityLabel}
      accessibilityRole={a11y_role}
    />
  );
});

MainLoader.displayName = 'MainLoader';
